import { ReactNode } from 'react';

import { ImageProps } from 'next/image';

import * as S from './styles';

interface IContentBox {
  children: ReactNode;
  leftImageSrc?: string;
  rightImageSrc?: string;
  className?: string;
  imageMarginTop?: number | string;
  additionalLeftImageProps?: Omit<ImageProps, 'src' | 'alt'>;
  additionalRightImageProps?: Omit<ImageProps, 'src' | 'alt'>;
}

const ContentBox = ({
  children,
  leftImageSrc,
  rightImageSrc,
  className,
  imageMarginTop,
  additionalLeftImageProps,
  additionalRightImageProps
}: IContentBox) => (
  <S.ContentBox className={className}>
    {leftImageSrc && (
      <S.ContentImageWrapper
        style={{ marginTop: imageMarginTop }}
        leftImageSrc={leftImageSrc}
        rightImageSrc={rightImageSrc}
      >
        <S.ContentImage
          src={leftImageSrc}
          height={450}
          width={450}
          {...additionalLeftImageProps}
          key={leftImageSrc}
        />
      </S.ContentImageWrapper>
    )}
    {rightImageSrc && (
      <S.ContentImageWrapper
        style={{ marginTop: imageMarginTop }}
        leftImageSrc={leftImageSrc}
        rightImageSrc={rightImageSrc}
      >
        <S.ContentImage
          src={rightImageSrc}
          height={450}
          width={450}
          {...additionalRightImageProps}
          key={rightImageSrc}
        />
      </S.ContentImageWrapper>
    )}
    <S.ContentWrapper leftImageSrc={leftImageSrc} rightImageSrc={rightImageSrc}>
      <S.Content leftImageSrc={leftImageSrc} rightImageSrc={rightImageSrc}>
        {children}
      </S.Content>
    </S.ContentWrapper>
  </S.ContentBox>
);

export default ContentBox;
